var _mask, _path, _mask2, _path2, _mask3, _path3, _path4, _mask4, _path5, _mask5, _path6, _path7, _mask6, _path8, _mask7, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVacationHome = function SvgVacationHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 30.43a.43.43 0 0 1 .43-.43h4.14a.43.43 0 0 1 .43.43v6.141a.43.43 0 0 1-.429.429H18.43a.43.43 0 0 1-.429-.429z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 30.43c0-.79.64-1.43 1.43-1.43h4.14c.79 0 1.43.64 1.43 1.43L22 31h-3zM23 37h-5zm-4.571 0c-.79 0-1.429-.64-1.429-1.429V30.43c0-.79.64-1.43 1.43-1.43l.57 2v6zm4.141-8c.79 0 1.43.64 1.43 1.43v5.141c0 .79-.64 1.429-1.429 1.429H22v-6z",
    mask: "url(#vacation-home_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 28.25a4.5 4.5 0 0 1 4.5-4.5h1.885c.34 0 .615.275.615.615v8.136a.25.25 0 0 1-.25.249H10.5a4.5 4.5 0 0 1-4.5-4.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    d: "M6 28.25a4.5 4.5 0 0 1 4.5-4.5h1.885c.34 0 .615.275.615.615v8.136a.25.25 0 0 1-.25.249H10.5a4.5 4.5 0 0 1-4.5-4.5Z",
    mask: "url(#vacation-home_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 37.32a.43.43 0 0 1-.43.43h-2.14a.43.43 0 0 1-.43-.43v-4.57h2.571c.237 0 .429.192.429.429z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 37.32c0 .79-.64 1.43-1.43 1.43h-2.14c-.79 0-1.43-.64-1.43-1.43l2-.57h1zm-4-4.57h3zm2.571 0c.79 0 1.429.64 1.429 1.429v3.141c0 .79-.64 1.43-1.43 1.43l-.57-2v-4zm-2.141 6c-.79 0-1.43-.64-1.43-1.43v-4.57h2v4z",
    mask: "url(#vacation-home_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.894,
    d: "M40.5 26.197h-3.053v6.106H40.5a3.053 3.053 0 1 0 0-6.106Z"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 24.2a2.45 2.45 0 0 0-2.45-2.45h-1.617a.933.933 0 0 0-.933.933v3.789c0 .098.08.178.178.178h2.372A2.45 2.45 0 0 0 42 24.2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    d: "M42 24.2a2.45 2.45 0 0 0-2.45-2.45h-1.617a.933.933 0 0 0-.933.933v3.789c0 .098.08.178.178.178h2.372A2.45 2.45 0 0 0 42 24.2Z",
    mask: "url(#vacation-home_svg__d)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 37.32c0 .237.193.43.43.43h2.14a.43.43 0 0 0 .43-.43v-4.57h-2.571a.43.43 0 0 0-.429.429z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36 37.32c0 .79.64 1.43 1.43 1.43h2.14c.79 0 1.43-.64 1.43-1.43l-2-.57h-1zm4-4.57h-3zm-2.571 0c-.79 0-1.429.64-1.429 1.429v3.141c0 .79.64 1.43 1.43 1.43l.57-2v-4zm2.141 6c.79 0 1.43-.64 1.43-1.43v-4.57h-2v4z",
    mask: "url(#vacation-home_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M25 9 12.5 19.929v17.357h24.857V19.714z"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22a3 3 0 1 1 6 0v2.786a.214.214 0 0 1-.214.214h-5.572a.214.214 0 0 1-.214-.214z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    d: "M17 22a3 3 0 1 1 6 0v2.786a.214.214 0 0 1-.214.214h-5.572a.214.214 0 0 1-.214-.214z",
    mask: "url(#vacation-home_svg__f)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "vacation-home_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 22a3 3 0 1 1 6 0v2.786a.214.214 0 0 1-.214.214h-5.572a.214.214 0 0 1-.214-.214z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    d: "M27 22a3 3 0 1 1 6 0v2.786a.214.214 0 0 1-.214.214h-5.572a.214.214 0 0 1-.214-.214z",
    mask: "url(#vacation-home_svg__g)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M27.75 31v6M29.75 31v6M31.75 31v6M33.75 31v6M35 31h-8.5M19.994 19.996v4M29.994 19.996v4"
  })));
};
export default SvgVacationHome;